import counterUp from './counter-up'

let observer = undefined

export function createObserver(headerHeight) {
    if (observer)
        observer.disconnect();

    const counterUpCallback = entries => {
        for (let entry of entries) {
            const el = entry.target
            if (entry.isIntersecting) {
                requestAnimationFrame(() => {
                    if (el.style.opacity !== '1') {
                        el.style.opacity = '1'
                    }

                    counterUp(el)
                    observer.unobserve(el)
                })
            }
        }
    }

    //console.log(`-${headerHeight}px 0px 0px 0px`)
    observer = new IntersectionObserver(counterUpCallback, {
        root: null,
        rootMargin: `-${headerHeight}px 0px 0px 0px`,
        threshold: 1,
    })

    const milestones = document.getElementsByClassName('General--Milestones')
    for (let milestone of milestones) {
        const milestone_numbers = milestone.getElementsByClassName('CountUp')

        for (let milestone_number of milestone_numbers) {
            if (milestone_number.style.opacity === '') {
                milestone_number.style.opacity = '0'
                for (let Fix of milestone_number.parentElement.getElementsByClassName('Fix')) {
                    Fix.style.opacity = '0'
                }
            }

            observer.observe(milestone_number)
        }
    }
}
